// @ts-check

import { VAlert } from 'vuetify/components/VAlert'
import { VProgressCircular } from 'vuetify/components/VProgressCircular'

/** @type {VAlert['$props']} */
export const AlertProps = {
  border: 'start',
  variant: 'tonal',
  class: 'alert',
  density: 'comfortable'
}

/** @type {VAlert['$props']} */
const SuccessAlert = {
  ...AlertProps,
  type: 'success',
  color: 'success',
  icon: '$check'
}

/** @type {VAlert['$props']} */
const InfoAlert = {
  ...AlertProps,
  type: 'info',
  color: 'primary',
  icon: '$information-outline'
}

const WarningAlert = {
  ...AlertProps,
  type: 'warning',
  color: 'primary',
  icon: '$alert-circle-outline'
}

/** @type {VAlert['$props']} */
const DangerAlert = {
  ...AlertProps,
  type: 'error',
  icon: '$alert-circle-outline'
}

export const aliases = {
  InfoAlert: VAlert,
  DangerAlert: VAlert,
  WarningAlert: VAlert,
  SuccessAlert: VAlert,
  ProgressCircular: VProgressCircular
}

export const defaults = {
  InfoAlert,
  DangerAlert,
  WarningAlert,
  SuccessAlert,
  VAlertTitle: {
    class: 'heading-3 text-lg!'
  },
  ProgressCircular: {
    color: 'primary',
    indeterminate: true
  }
}
